// @ts-check

import ApiUtils from '@/utils/api/ApiUtils'
import ObjArrUtils from '@/utils/ObjArrUtils'
// import i18n from '@/plugins/i18n'
import _module from '@/store/base/module'

const module = {
  state: {
    enrollerAttendance: []
  },

  getters: {
    getEnrollerAttendance: state => state.enrollerAttendance
  },

  mutations: {
    SET_ENROLLER_ATTENDANCE (state, payload) {
      state.enrollerAttendance = payload
    }
  },

  actions: {
    initContentClassSession: ({ commit }, input) => {
      return ApiUtils.postData({
        data: [
          { api: 'L0401ContentClassSessionService.getContentClassSession', input },
          { api: 'L0301ContentClassService.getContentClassEnrollerAttendance', input }
        ]
      })
        .then(data => {
          commit('SET_ROW', data[0].output)
          commit('SET_ENROLLER_ATTENDANCE', data[1].output)
        })
    },
    manuallyMarkAttendance: ({ commit }, input) => {
      return ApiUtils.postData({ data: [{ api: 'L0801ContentClassSessionAttendanceService.manuallyMarkAttendance', input }] })
        .then((data) => {

        })
    },
    attendanceCheckIn: ({ commit }, input) => {
      return ApiUtils.postData({ data: [{ api: 'L0801ContentClassSessionAttendanceService.attendanceCheckIn', input }] })
        .then((data) => {
          return data[0].output
        })
        .catch((e) => {
          return null
        })
    }
  }
}

export default ObjArrUtils.merge(_module, module)
